import easydropdown from 'easydropdown-a11y'
import '@styles/components/dropdown.css'
import { on } from 'delegated-events'
import ajax from '@common/ajax'
import scrollTo from '@common/scroll-to'
import { generateUrl } from '@common/util'

const form = document.querySelector('.filter-form')

const setupDropdown = (el) => {
  if (el.tagName !== 'SELECT') {
    return
  }

  const opts = {
    behavior: {
      openOnFocus: true,
      maxVisibleItems: 10,
      liveUpdates: true,
      useNativeUiOnMobile: false,
    },
  }

  easydropdown(el, opts)
}

const handleFilterChange = (e) => {
  e && e.preventDefault()

  const params = new FormData(form)
  const url = generateUrl(form, params)

  window.history.replaceState({}, '', url)

  updateResults()
}

const handleFilterClear = () => {
  form.reset()
  form.querySelectorAll('select').forEach((x) => (x.value = ''))
  form.querySelectorAll('input[type="search"]').forEach((x) => (x.value = null))

  window.history.replaceState({}, '', form.action)

  updateResults()
}

const updateResults = async () => {
  const pageContent = document.querySelector('[data-page-content]')

  pageContent.classList.add('is-loading')

  const res = await ajax.get(window.location.href).json()

  pageContent.innerHTML = res.page
  pageContent.classList.remove('is-loading')

  if (res.isFiltered) {
    form.classList.add('is-filtered')
    scrollTo(pageContent)
  } else {
    form.classList.remove('is-filtered')
  }
}

const init = () => {
  form.querySelectorAll('select:not([multiple])').forEach((el) => setupDropdown(el))

  on('change', '.filter-form select', handleFilterChange)
  on('submit', '.filter-form', handleFilterChange)
  on('click', '.filter-form-clear', handleFilterClear)
}

init()
